type AuthFetch = {
  path: string;
  method?: string;
  data?: any;
  contentType?: string;
};

export async function authFetch({
  path,
  method = "GET",
  data,
  contentType = "application/json",
}: AuthFetch) {

  const headers : any = {
    Authorization: `Bearer ${JSON.parse(localStorage.getItem("@app:token") || '')}`,
  };
  let body = data;
  if (contentType === "application/json") {
    body = JSON.stringify(data);
    headers["Content-Type"] = contentType;
  }

  const response = await fetch(`${path}`, {
    body,
    method,
    headers,
    redirect: "follow",
  });

  if (response.status === 403) {
    return Promise.reject(response);
  }

  return Promise.resolve(response);
}
